export default "__VITE_ASSET__ClnmQzN5__"